 

import React from 'react'
import { Modal } from "react-bootstrap"
import { FaExclamationTriangle, FaTimes } from "react-icons/fa"

const ConfirmationModal = ({
  show,
  title,
  message,
  confirmButtonText,
  cancelButtonText = "Cancel",
  confirmButtonVariant = "danger",
  onConfirm,
  onCancel,
}) => {
  // Determine button color based on variant
  const getButtonColor = (variant) => {
    switch (variant) {
      case "danger":
        return { background: "#dc3545", hover: "#c82333" }
      case "primary":
        return { background: "#1e3a5f", hover: "#152a45" }
      case "success":
        return { background: "#28a745", hover: "#218838" }
      case "warning":
        return { background: "#ffc107", hover: "#e0a800" }
      default:
        return { background: "#dc3545", hover: "#c82333" }
    }
  }

  const buttonColors = getButtonColor(confirmButtonVariant)

  const modalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    dialog: {
      maxWidth: "420px",
      margin: "1.75rem auto",
    },
    content: {
      border: "none",
      borderRadius: "12px",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)",
      overflow: "hidden",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "20px 24px",
      borderBottom: "1px solid #e9ecef",
      backgroundColor: "#fff",
    },
    titleWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    iconBadge: {
      width: "40px",
      height: "40px",
      borderRadius: "10px",
      backgroundColor: confirmButtonVariant === "danger" ? "#fff5f5" : "#f0f7ff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    icon: {
      color: confirmButtonVariant === "danger" ? "#dc3545" : "#1e3a5f",
      fontSize: "18px",
    },
    title: {
      margin: 0,
      fontSize: "18px",
      fontWeight: "600",
      color: "#1e3a5f",
    },
    closeButton: {
      background: "none",
      border: "none",
      padding: "8px",
      cursor: "pointer",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#6c757d",
      transition: "all 0.2s ease",
    },
    body: {
      padding: "24px",
      backgroundColor: "#fff",
    },
    message: {
      margin: 0,
      fontSize: "15px",
      color: "#495057",
      lineHeight: "1.6",
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "12px",
      padding: "16px 24px",
      borderTop: "1px solid #e9ecef",
      backgroundColor: "#f8f9fa",
    },
    cancelButton: {
      padding: "10px 20px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#495057",
      backgroundColor: "#fff",
      border: "1px solid #dee2e6",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    confirmButton: {
      padding: "10px 20px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#fff",
      backgroundColor: buttonColors.background,
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
  }

  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      style={modalStyles.overlay}
      dialogClassName="custom-modal-dialog"
    >
      <div style={modalStyles.content}>
        {/* Custom Header */}
        <div style={modalStyles.header}>
          <div style={modalStyles.titleWrapper}>
            <div style={modalStyles.iconBadge}>
              <FaExclamationTriangle style={modalStyles.icon} />
            </div>
            <h5 style={modalStyles.title}>{title}</h5>
          </div>
          <button
            style={modalStyles.closeButton}
            onClick={onCancel}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f1f3f4"
              e.currentTarget.style.color = "#1e3a5f"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent"
              e.currentTarget.style.color = "#6c757d"
            }}
          >
            <FaTimes size={16} />
          </button>
        </div>

        {/* Body */}
        <div style={modalStyles.body}>
          <p style={modalStyles.message}>{message}</p>
        </div>

        {/* Footer */}
        <div style={modalStyles.footer}>
          <button
            style={modalStyles.cancelButton}
            onClick={onCancel}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f1f3f4"
              e.currentTarget.style.borderColor = "#c6c9cc"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#fff"
              e.currentTarget.style.borderColor = "#dee2e6"
            }}
          >
            {cancelButtonText}
          </button>
          <button
            style={modalStyles.confirmButton}
            onClick={onConfirm}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = buttonColors.hover
              e.currentTarget.style.transform = "translateY(-1px)"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = buttonColors.background
              e.currentTarget.style.transform = "translateY(0)"
            }}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
